import { render, staticRenderFns } from "./uppy_prolong.vue?vue&type=template&id=911da4c6&scoped=true"
import script from "./uppy_prolong.vue?vue&type=script&lang=js"
export * from "./uppy_prolong.vue?vue&type=script&lang=js"
import style0 from "./uppy_prolong.vue?vue&type=style&index=0&id=911da4c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "911da4c6",
  null
  
)

export default component.exports